/* eslint-disable no-unused-vars */
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

interface Props extends Omit<ReactDatePickerProps, 'onChange'> {
  value: string | undefined
  emptyValue?: string | null
  onChange: (v: any) => void
}

const DateTimePicker: React.FC<Props> = ({
  value,
  emptyValue,
  onChange,
  ...rest
}) => {
  if (emptyValue && !value) {
    return <div className="empty-value">{emptyValue}</div>
  }
  return (
    <li className="form-field">
      <ReactDatePicker
        shouldCloseOnSelect
        // @ts-ignore
        selected={typeof value === 'string' ? new Date(value) : value}
        portalId="root-portal"
        // @ts-ignore
        onChange={onChange}
        {...rest}
      />
    </li>
  )
}

export default DateTimePicker
